import type { ILeadSubscriptionItem } from 'models/lead.model'

export const getHasBasicSubscription = (
  subscriptions: ILeadSubscriptionItem[] | null,
): boolean =>
  !!subscriptions?.find(
    ({ planOnboardingType, status }) =>
      (planOnboardingType === 'purchase' ||
        planOnboardingType === 'cancelOffer') &&
      (status === 'active' ||
        status === 'active_paused' ||
        status === 'active_resuming' ||
        status === 'trial' ||
        status === 'trial_paused' ||
        status === 'dunning' ||
        status === 'trial_cancel_requested' ||
        status === 'active_cancel_requested' ||
        status === 'active_extended'),
  )
